export function getSurveyJsFirstElement(schema) {
  const pages = schema?.pages;
  if (!Array.isArray(pages)) return null;
  for (const page of pages) {
    if (!Array.isArray(page?.elements)) continue;
    for (const el of page.elements) {
      if (el && typeof el === "object" && el.name) return el;
    }
  }
  return null;
}

export function surveyJsValueToIndex(element, value) {
  const choices = Array.isArray(element?.choices) ? element.choices : [];
  return choices.findIndex((c) => c && c.value === value);
}

export function surveyJsAnswerJson(poll, selectedIndex) {
  const el = getSurveyJsFirstElement(poll?.question);
  if (!el) return JSON.stringify([{ selectedIndex }]);
  return JSON.stringify([{ ...el, selectedIndex }]);
}
